// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leadPanelPanel {
  background-color: #ffffff;
  box-shadow: 0px 8px 48px -8px rgba(0, 0, 0, 0.24);
  width: 640px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 48px;
  padding-top: 24px;
  height: calc(100% - 144px);
}

.leadPanelTop {
  width: 100%;
}

.leadPanelBottom {
  height: 100%;
  overflow: auto;
  width: calc(100% - 24px);
  padding-left: 24px;
  padding-bottom: 24px;
}

.leadPanelId,
.leadPanelHeader {
  padding: 0 24px;
}

.leadPanelcloseBtn {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  top: 0;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: -10px 0px 48px -8px rgba(0, 0, 0, 0.24);
}

.MuiTypography-root.leadPanelId {
  color: #707172;
}

.MuiTypography-root.leadPanelId a {
  color: #707172;
  cursor: pointer;
  text-decoration: none;
}

.leadPanelHeader {
  display: flex;
  align-items: center;
  width: calc(100% - 48px);
}

.MuiTypography-root.leadPanelTitle {
  color: #383939;
  flex-grow: 1;
}

.MuiTypography-root.leadDeailsLinkCRM {
  color: #14679f;
  font-weight: 600;
}

.leadPanelTabs {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #707172;
}
.leadPanelTabs a {
  width: 50%;
}

.MuiTypography-root.leadPanelTab {
  font-weight: 600;
  color: #14679f;
  cursor: pointer;
  margin-top: 8px;
  padding: 12px 0px 8px 24px;
}

.MuiTypography-root.leadPanelTab.active {
  color: #252626;
  border-bottom: 4px solid #187fc4;
}

.MuiTypography-root.noLeadMessage {
  width: 320px;
  text-align: center;
  color: #707172;
}

.rightPanel > svg path,
.rightPanel > svg circle {
  stroke: #707172;
}

.leadContactNoContact {
  padding: 0 24px 24px 24px;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/LeadPanel/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".leadPanelPanel {\n  background-color: #ffffff;\n  box-shadow: 0px 8px 48px -8px rgba(0, 0, 0, 0.24);\n  width: 640px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: absolute;\n  top: 48px;\n  padding-top: 24px;\n  height: calc(100% - 144px);\n}\n\n.leadPanelTop {\n  width: 100%;\n}\n\n.leadPanelBottom {\n  height: 100%;\n  overflow: auto;\n  width: calc(100% - 24px);\n  padding-left: 24px;\n  padding-bottom: 24px;\n}\n\n.leadPanelId,\n.leadPanelHeader {\n  padding: 0 24px;\n}\n\n.leadPanelcloseBtn {\n  width: 48px;\n  height: 48px;\n  position: absolute;\n  left: -48px;\n  top: 0;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: -10px 0px 48px -8px rgba(0, 0, 0, 0.24);\n}\n\n.MuiTypography-root.leadPanelId {\n  color: #707172;\n}\n\n.MuiTypography-root.leadPanelId a {\n  color: #707172;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.leadPanelHeader {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 48px);\n}\n\n.MuiTypography-root.leadPanelTitle {\n  color: #383939;\n  flex-grow: 1;\n}\n\n.MuiTypography-root.leadDeailsLinkCRM {\n  color: #14679f;\n  font-weight: 600;\n}\n\n.leadPanelTabs {\n  width: 100%;\n  display: flex;\n  border-bottom: 1px solid #707172;\n}\n.leadPanelTabs a {\n  width: 50%;\n}\n\n.MuiTypography-root.leadPanelTab {\n  font-weight: 600;\n  color: #14679f;\n  cursor: pointer;\n  margin-top: 8px;\n  padding: 12px 0px 8px 24px;\n}\n\n.MuiTypography-root.leadPanelTab.active {\n  color: #252626;\n  border-bottom: 4px solid #187fc4;\n}\n\n.MuiTypography-root.noLeadMessage {\n  width: 320px;\n  text-align: center;\n  color: #707172;\n}\n\n.rightPanel > svg path,\n.rightPanel > svg circle {\n  stroke: #707172;\n}\n\n.leadContactNoContact {\n  padding: 0 24px 24px 24px;\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
